/* eslint-disable no-unused-vars */
/* eslint-disable no-redeclare */
"use strict";

var canopyCore = angular.module("canopyCore", ["ui.router", "ui.bootstrap", "ngAnimate", "ngSanitize", "dndLists"]);